import actionComposer from 'utilities/actionComposer';
import { api_orderAgain } from './api';

export const ORDER_AGAIN = actionComposer('ORDER_AGAIN');
export const orderAgain = orderId => ({
  type: ORDER_AGAIN.type,
  payload: api_orderAgain(orderId)
});
